import AssessmentDetail from "pages/Courses/AssessmentDetails";
import CourseDetail from "pages/Courses/CourseDetail";
import Courses from "pages/Courses/Courses";
import Dashboard from "pages/Dashboards/Dashboard";
import ChannelPartnerProfile from "pages/Profile/ChannelPartnerProfile";
import TraineeListing from "pages/Trainee/TraineeListing";
import CoursePurchase from "pages/Courses/CoursePurchase";
import AddTrainee from "pages/Trainee/AddTrainee";
import CsvTraineeImport from "pages/CsvImport/CsvTraineeImport";
import Questions from "pages/QuestionBank/Questions";
import TraineeDetails from "pages/Trainee/TraineeDetails";

const routes = [
  {
    show: true,
    path: "/dashboard",
    name: "Dashboards",
    icon: "ni ni-shop text-deep-blue",
    component: <Dashboard />,
    layout: "/channel-partner",
    roles: ["ADMIN", "CHANNEL_PARTNER", "TRAINER"],
  },
  {
    show: false,
    path: "/profile",
    name: "Channel Partner Profile",
    icon: "ni ni-shop text-deep-blue",
    component: <ChannelPartnerProfile />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  // My Courses list
  {
    show: true,
    path: "/my-courses",
    name: "My Courses",
    icon: "ni ni-hat-3 text-deep-blue",
    component: <Courses />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  // My Course Details (all tabs)
  {
    show: false,
    path: "/my-courses/:id/details",
    name: "My Course Detail",
    icon: "ni ni-shop text-deep-blue",
    component: <CourseDetail />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  // Courses list
  {
    show: true,
    path: "/course",
    name: "Courses",
    icon: "ni ni-hat-3 text-deep-blue",
    component: <Courses />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  // Course Details (only 2 tabs)
  {
    show: false,
    path: "/course/:id/details",
    name: "Course Detail",
    icon: "ni ni-shop text-deep-blue",
    component: <CourseDetail />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: false,
    path: "/course/:id/purchase",
    name: "Course Purchase",
    icon: "ni ni-shop text-deep-blue",
    component: <CoursePurchase />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: false,
    path: "/course/:id/details",
    name: "Course Detail",
    icon: "ni ni-shop text-deep-blue",
    component: <CourseDetail />,
    layout: "/instructor",
    roles: ["TRAINER"],
  },
  {
    show: false,
    path: "/course/:id/details/:assessmentId",
    name: "Assessment Detail",
    icon: "ni ni-shop text-deep-blue",
    component: <AssessmentDetail />,
    layout: "/instructor",
    roles: ["TRAINER"],
  },
  {
    show: true,
    path: "/trainee",
    name: "Trainees",
    icon: "fa-solid fa-user-graduate pr-3 text-deep-blue",
    component: <TraineeListing />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: false,
    path: "/trainee/:id/details",
    name: "Trainee Detail",
    icon: "ni ni-shop text-deep-blue",
    component: <TraineeDetails />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: false,
    path: "/trainee/add-trainee",
    name: "Add-Trainee",
    icon: "ni ni-single-02 text-deep-blue",
    component: <AddTrainee />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: false,
    path: "/trainee/edit/:id",
    name: "Add-Trainee",
    icon: "ni ni-single-02 text-deep-blue",
    component: <AddTrainee />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: false,
    path: "/trainee/:id/details",
    name: "Trainee Details",
    icon: "ni ni-single-02 text-deep-blue",
    component: <TraineeDetails />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: false,
    path: "/course/:id/purchase/add-trainee",
    name: "Add Trainee",
    icon: "ni ni-shop text-deep-blue",
    component: <AddTrainee />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: false,
    path: "/course/:id/purchase/import-trainee",
    name: "Add Trainee",
    icon: "ni ni-shop text-deep-blue",
    component: <CsvTraineeImport />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
  {
    show: false,
    path: "/question-bank/add/questions",
    name: "Question Bank",
    icon: "ni ni-collection text-deep-blue",
    component: <Questions />,
    layout: "/channel-partner",
    roles: ["CHANNEL_PARTNER"],
  },
];

export default routes;
